import { Languages } from "lucide-react";
import { Button } from "./ui/button";
import { cn } from "./ui/utils";
import { useLanguage } from "../i18n/language-provider";

interface LanguageToggleProps {
  /**
   * Render the code alone, sized like the icon buttons beside it.
   *
   * The labelled form measures ~1.7x an icon button: wider than a column of
   * the rail's footer, and wider than the 3rem the collapsed rail leaves it,
   * where it hung over both of the rail's edges. The glyph is what goes: it is
   * decorative, while the code is the control's whole accessible name, so
   * dropping the code instead would leave a button nothing names.
   */
  compact?: boolean;
  /**
   * The outline box is drawn for the paper pages and paints their background.
   * The rail draws its controls as bare icons in its own colours, so it asks
   * for `ghost` and passes those colours as `className`.
   */
  variant?: "outline" | "ghost";
  className?: string;
}

export function LanguageToggle({ compact = false, variant = "outline", className }: LanguageToggleProps) {
  const { language, setLanguage } = useLanguage();

  return (
    <Button
      variant={variant}
      size={compact ? "icon" : "sm"}
      onClick={() => setLanguage(language === "en" ? "cs" : "en")}
      className={cn(!compact && "gap-1.5 px-2.5", className)}
    >
      {!compact && <Languages className="h-4 w-4" />}
      <span className="text-xs font-medium uppercase">{language === "en" ? "CZ" : "EN"}</span>
    </Button>
  );
}
